import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: "0px 16px 14px 16px",
    maxWidth: "700px",
  },
  status: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.grey[800],
    margin: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(28),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.grey[800],
    marginBottom: theme.spacing(2),
    margin: 0,
  },
  type: {
    fontSize: theme.typography.pxToRem(15),
    margin: "2px 0 20px 0",
    color: theme.palette.grey[800],
  },
  amountText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.grey[500],
    fontWeight: 500,
    paddingBottom: "2px",
  },
  amount: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(24),
    margin: 0,
  },
  commissionAmount: {
    fontSize: theme.typography.pxToRem(16),
  },
  positiveValue: {
    color: theme.palette.success.main,
  },
  negativeValue: {
    color: theme.palette.error.main,
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[800],
  },
  commissionDescription: {
    textTransform: "capitalize",
  },
  commissionDetail: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.grey[500],
  },
  cardNumber: {
    marginLeft: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    color: theme.palette.grey[800],
  },
  detailCard: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: "4px",
    display: "flex",
    padding: "40px",
    color: theme.palette.text.primary,
    position: "relative",
  },
  noData: {
    fontSize: theme.typography.pxToRem(20),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  divider: {
    "&.MuiDivider-root": {
      margin: "22px 0 22px 0",
    },
  },
  actionPanel: {
    width: "100%",
  },
  actionPanelContainer: {
    height: "100%",
  },
  buttonsList: {
    height: "calc(100% - 85px)",
    marginBottom: "5px",
  },
  buttonMargin: {
    marginTop: "10px",
  },
  returnButtonList: {
    height: "60px",
  },
  gridSpacing: {
    marginBottom: "6px",
  },
  loadingIcon: {
    color: theme.palette.grey[600],
  },
  dialogTextInput: {
    width: "100%",
  },
  buttonConfirm: {
    color: theme.palette.text.pitchWhite,
  },
  returnedChip: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.grey[300],
    marginLeft: theme.spacing(1),
    verticalAlign: "bottom",
  },
  returnChip: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    marginLeft: theme.spacing(1),
    verticalAlign: "bottom",
  },
}));
